import { PaginationConfig as PaginationConfigI } from '@cpak/interfaces';
import { InfinityScrollConfig as InfinityScrollConfigI } from '@cpak/interfaces';
import { MenuConfig } from '../interfaces';
import { createPakKeys } from '../enums';

export const PaginationConfig: PaginationConfigI = {
  limit: 30,
  limitShort: 3,
  startPage: 0,
  offset: 0,
};

export const InfinityScrollConfig: InfinityScrollConfigI = {
  scrollDistance: 2,
  scrollThrottle: 150,
};

export const salesforceLabel = 'Salesforce';
export const utilitiesLabel = 'Utilities';
export const noContractAdminMessage = 'needContractAdminIdToSubmit';

export const expandStoragePrefix = 'expand-state';

export const INVALID_PAGE = -1;

export const ALL_OPTIONS = 'all';

export const USA_COUNTRY_CODE = 'US';

export const MAX_ERRORS_COUNT = 1;

export const POLLING_INTERVAL = 30000; // 30 seconds

export const ratingConfig = {
  maxRating: 5,
};

export const newPackId = 'newPackId';

export const createPakMenuConfig: MenuConfig<createPakKeys>[] = [
  {
    id: createPakKeys.FromExistingPack,
    label: 'fromExistingPack',
    icon: 'alc-icon-library-add',
  },
  /*
   {
    id: createPakKeys.FromTemplate,
    label: 'fromTemplate',
    icon: 'alc-icon-document-scanner',
  }, */
  {
    id: createPakKeys.FromScratch,
    label: 'fromScratch',
    icon: 'alc-icon-note-add',
  },
  {
    id: createPakKeys.SmartRevisions,
    label: 'smartRevisions',
    icon: 'alc-icon-smart-revisions-light-bulb',
  },
];

export const ACCOUNT_UNASSIGNED_ID = 'unassigned_packs';
export const unassignedPakLabel = 'unassignedPackLabel';
export const unassignedPakTitle = 'unassignedPackTitle';
export const unassignedPak = {
  id: ACCOUNT_UNASSIGNED_ID,
  name: unassignedPakTitle,
};

export const ACCOUNT_SHARED_ID = 'shared_packs';
export const sharedPakLabel = 'sharedPackLabel';
export const sharedPakTitle = 'sharedPackTitle';
export const sharedPak = {
  id: ACCOUNT_SHARED_ID,
  name: sharedPakTitle,
};

export const DEFAULT_LANG = 'en-US';
export const DEFAULT_TIMEZONE = 'US/Central';

export const headers = {
  'Content-Type': 'application/json',
  'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
  'Cache-Control': 'no-cache',
  'Accept-Language': DEFAULT_LANG,
  Pragma: 'no-cache',
};
